<div class="order-visit">
    <div class="flex items-center justify-between flex-wrap gap-2 mb-1">
        <h5 class="m-0">Order Visit</h5>
        <div class="flex items-center flex-wrap gap-2">
            <button
                nz-button
                nzType="link"
                nzSize="small"
                class="order-visit-refresh"
                nz-tooltip="Refresh visit"
                [nzLoading]="isLoadingVisit"
                [disabled]="isCancelingVisit"
                (click)="loadVisit()"
            >
                <i class="fa fa-refresh" *ngIf="!isLoadingVisit"></i>
            </button>
            <button
                nz-button
                nzSize="small"
                nzDanger
                nzType="primary"
                [nzLoading]="isCancelingVisit"
                [disabled]="isLoadingVisit || isCancelingVisit"
                (click)="confirmCancelVisit()"
            >
                Cancel Visit
            </button>
        </div>
    </div>

    <nz-spin [nzSpinning]="isLoadingVisit && !visit && !visitError">
        <div *ngIf="visitError" class="text-red-500 text-sm mt-1 ml-1">
            {{ visitError }}
        </div>

        <div
            *ngIf="visit"
            class="flex flex-row flex-wrap text-sm mt-1"
        >
            <div
                class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1"
            >
                <span class="font-bold">Status:</span>
                <nz-tag [nzColor]="visitStatusColor" class="m-0">
                    {{ visit.visitStatus | titlecase }}
                </nz-tag>
            </div>
            <div
                *ngIf="visit.prescriberNetwork"
                class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1"
            >
                <span class="font-bold">Prescriber Network:</span>
                <span>{{ visit.prescriberNetwork | titlecase }}</span>
            </div>
            <div
                class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1 cursor-pointer"
                nz-tooltip="Copy value"
                (click)="copyMasterId()"
            >
                <span class="font-bold">Visit ID:</span>
                <span>{{ visit.masterId || masterId }}</span>
            </div>
            <div
                class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1"
            >
                <span class="font-bold">MedID(s) submitted:</span>
                <span>{{ submittedMedIdsLabel }}</span>
            </div>
            <div
                *ngIf="visit.scheduleLink"
                class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1"
            >
                <span class="font-bold">Schedule Link:</span>
                <a [href]="visit.scheduleLink" target="_blank" rel="noopener">
                    Open scheduling
                </a>
            </div>
        </div>
    </nz-spin>
</div>
